import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const PlanningMenu = (props) => {
  const { t, handleNavItemClick, handleContextMenu } = props;
  const params = useParams();

  const clientOrderIdId = parseInt(params.clientOrderId, 10);
  const dispatch = useDispatch();

  return (
    <div className="sub-list">
      <ul>
        <li
          data-link="/planning/orders"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={
            params.path === "orders" || clientOrderIdId ? "active" : ""
          }
        >
          {t("MENU_PLANNING_CLIENT_ORDERS")}
        </li>

        <li
          data-link="/planning/daily"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "daily" ? "active" : ""}
        >
          {t("MENU_PLANNING_SUPPLIERS")}
        </li>

        <li
          data-link="/planning/global"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "global" ? "active" : ""}
        >
          {t("MENU_PLANNING_GLOBAL")}
        </li>

        <li
          data-link="/planning/disputes"
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "disputes" ? "active" : ""}
        >
          {t("MENU_PLANNING_DISPUTES")}
        </li>
      </ul>
    </div>
  );
};

PlanningMenu.propTypes = {
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func.isRequired,
  handleContextMenu: PropTypes.func.isRequired,
};

export default withTranslation()(PlanningMenu);
